import gql from 'graphql-tag';

import accountFragment from '../fragments/accountFragment';

export const queryAccount = gql`
  query account {
    account {
      ...accountFragment
    }
  }
  ${accountFragment}
`;
export default queryAccount;
